import { render, staticRenderFns } from "./ClerksNewFaults.vue?vue&type=template&id=cb309c1e&scoped=true&"
import script from "./ClerksNewFaults.vue?vue&type=script&lang=js&"
export * from "./ClerksNewFaults.vue?vue&type=script&lang=js&"
import style0 from "./ClerksNewFaults.vue?vue&type=style&index=0&id=cb309c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb309c1e",
  null
  
)

export default component.exports